import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Accordion, Button, Icon, Label, Message } from 'semantic-ui-react';
import ZenBroadbandGroup from './ZenBroadbandGroup';
import './ZenAvailabilityResults.css';
import { showCustomMessage } from '../../libs/sessionVariable';

const SUPPLIER_COLOURS = {
  Vodafone: { label: 'red',    hex: '#e60000' },
  Zen:      { label: 'teal',   hex: '#008788' },
  Giganet:  { label: 'green',  hex: '#21ba45' },
};

function groupByProvider(broadbandGroups) {
  const map = {};
  for (const group of broadbandGroups) {
    const key = group.provider ?? 'Zen';
    if (!map[key]) map[key] = [];
    map[key].push(group);
  }
  return map;
}

function orderedProviders(grouped) {
  const keys = Object.keys(grouped);
  const others = keys.filter(k => k !== 'Vodafone');
  const vodafone = keys.filter(k => k === 'Vodafone');
  return [...others, ...vodafone];
}

export default function ZenAvailabilityResults({ results }) {
  const [selectedProduct, selectProduct] = useState(null);
  const [customMessage, setCustomMessage] = useState(false);
  const history = useHistory();
  const { broadbandGroups, lineDetails } = results;

  const grouped = groupByProvider(broadbandGroups);
  const providers = orderedProviders(grouped);

  const [openSections, setOpenSections] = useState(() => {
    const initial = {};
    for (const key of Object.keys(groupByProvider(broadbandGroups))) {
      initial[key] = true;
    }
    return initial;
  });

  useEffect(() => {
    async function customMesssageHook() {
      setCustomMessage(await showCustomMessage());
    }
    customMesssageHook();
  }, [customMessage]);

  function toggleSection(provider) {
    setOpenSections(prev => ({ ...prev, [provider]: !prev[provider] }));
  }

  function PlaceOrder() {
    sessionStorage.setItem('selectedProduct', JSON.stringify(selectedProduct));

    if (selectedProduct?.provider === 'Vodafone') {
      history.push('/PlaceVodafoneOrder');
      return;
    }

    if (selectedProduct?.broadbandType === "GFast" && selectedProduct?.orderDetails?.provision?.provisionType === 2) {
      history.push('/PlaceGFastMigrationOrder');
    }
    else if (selectedProduct?.broadbandType === "GFast" && selectedProduct?.orderDetails?.provision?.provisionType === 1) {
      history.push('/PlaceGFastNewProvideOrder');
    }
    else if (selectedProduct?.broadbandType === "GFast" && selectedProduct?.orderDetails?.provision?.provisionType === 4) {
      history.push('/PlaceGFastSIMProvideOrder');
    }
    else if (selectedProduct?.broadbandType === "FTTP" && selectedProduct?.orderDetails?.provision?.provisionType === 1) {
      history.push('/PlaceFTTPNewProvideOrder');
    }
    else if (
      selectedProduct?.broadbandType === "FTTP" &&
      selectedProduct?.orderDetails?.provision?.provisionType === 2 &&
      selectedProduct?.ports &&
      Object.keys(selectedProduct?.ports).length === 0
    ) {
      history.push('/PlaceFTTPMigrationOrder');
    }
    else if (
      selectedProduct?.broadbandType === "FTTP" &&
      selectedProduct?.orderDetails?.provision?.provisionType === 2
    ) {
      history.push('/PlaceFTTPMigrationOrNewOrder');
    }
    else if (selectedProduct?.broadbandType === "FTTP" && selectedProduct?.orderDetails?.provision?.provisionType === 5) {
      history.push('/PlaceFTTPSuccessionProvideOrder');
    }
    else if (selectedProduct?.broadbandType === "FTTP" && selectedProduct?.orderDetails?.provision?.provisionType === 6) {
      history.push('/PlaceFTTPSuccessionOrMigrationOrder');
    }
    else if (selectedProduct?.broadbandType === "FTTP" && selectedProduct?.orderDetails?.provision?.provisionType === 7) {
      history.push('/PlaceFTTPMigrationOrNewOrder');
    }
    else if (selectedProduct?.orderDetails?.provision?.provisionType === 1 && selectedProduct?.broadbandType === "Copper"
      || selectedProduct?.orderDetails?.provision?.provisionType === 2 && selectedProduct?.broadbandType === "Copper") {
      history.push('/PlaceZenCopperOrder');
    }
    else if (selectedProduct?.broadbandType === "SOTAP") {
      history.push('/PlaceZenCopperOrder');
    }
    else if (selectedProduct?.orderDetails?.provision?.provisionType === 4 && selectedProduct?.broadbandType === "Copper") {
      history.push('/PlaceZenSimProvideCopperOrder');
    }
    else if (selectedProduct?.orderDetails?.provision?.provisionType === 1 && selectedProduct?.broadbandType === "FTTC"
      || selectedProduct?.orderDetails?.provision?.provisionType === 2 && selectedProduct?.broadbandType === "FTTC") {
      history.push('/PlaceZenFTTCOrder');
    }
    else if (selectedProduct?.orderDetails?.provision?.provisionType === 4 && selectedProduct?.broadbandType === "FTTC") {
      history.push('/PlaceZenSimProvideFTTCOrder');
    }
    else if (selectedProduct?.broadbandType === "SOGEA" && selectedProduct?.orderDetails?.provision?.provisionType === 7 ||
      selectedProduct?.broadbandType === "SOGEA" && selectedProduct?.orderDetails?.provision?.provisionType === 1 ||
      selectedProduct?.broadbandType === "SOGEA" && selectedProduct?.orderDetails?.provision?.provisionType === 2) {
      history.push('/PlaceSOGEAOrder', { storage: selectedProduct });
    }
    else if (selectedProduct?.orderDetails?.provisionType === 'Migration' && selectedProduct?.broadbandType === 'FTTC' || selectedProduct?.orderDetails?.provisionType === 'NewProvide' && selectedProduct?.products?.provider === 'Fibre1' && selectedProduct?.broadbandType === 'FTTC') {
      history.push('/PlaceTtbFttcOverWlr');
    }
    else if (selectedProduct?.orderDetails?.provisionType === 'SimProvide' && selectedProduct?.broadbandType === 'FTTC' && selectedProduct?.orderDetails?.request.postCode) {
      history.push('/PlaceTtbFttcOverWlrSim');
    }
    else if (selectedProduct?.broadbandType === "FTTP SYMMETRICAL") {
      history.push('/placefttpsymmetrical', { storage: selectedProduct });
    }
  }

  return (
    <>
      <div className='zen-availability-results'>
        {providers.map(provider => {
          const groups = grouped[provider];
          const colour = SUPPLIER_COLOURS[provider] ?? { label: 'grey', hex: '#767676' };
          const isOpen = openSections[provider] !== false;
          const typeCount = groups.length;

          return (
            <Accordion
              key={provider}
              styled
              fluid
              className="provider-accordion"
            >
              <Accordion.Title
                active={isOpen}
                onClick={() => toggleSection(provider)}
                className="provider-accordion__title"
                style={{ borderLeftColor: colour.hex }}
              >
                <Icon name="dropdown" />
                <Label color={colour.label} size="small">{provider}</Label>
                <span className="provider-accordion__summary">
                  {typeCount} product {typeCount === 1 ? 'type' : 'types'} available
                </span>
              </Accordion.Title>

              <Accordion.Content active={isOpen} className="provider-accordion__content">
                {groups.map(broadbandGroup => (
                  <ZenBroadbandGroup
                    key={`${broadbandGroup.provider}_${broadbandGroup.broadbandType}`}
                    broadbandGroup={broadbandGroup}
                    selectProduct={selectProduct}
                    selectedProduct={selectedProduct}
                    lineDetails={lineDetails}
                  />
                ))}
              </Accordion.Content>
            </Accordion>
          );
        })}

        <Button
          disabled={selectedProduct === null}
          onClick={PlaceOrder}
          className='button-primary'
          floated='right'
          content='Place Order'
        />
      </div>

      {!lineDetails?.FttpSymmetrical && customMessage && (
        <Message success header='Unfortunately there are no FTTP Symmetrical products available at this location, please contact your account manager' />
      )}
    </>
  );
}
